/**
 * PREVENTION-ACTION.STORE.TS
 */
import { createEntityStore } from "@/core/factory/store"
import {
  createEmptyPreventionAction,
  isRpsPreventionAction,
  isRpsPreventionActionForPopulation,
  PREVENTION_ACTION_ENTITY,
  PreventionAction
} from "./prevention-action.types"
import { formatPreventionAction } from "./prevention-action.formatter"
import { add, remove, updateStatus } from "./prevention-action.thunk"
import { createSelector } from "@reduxjs/toolkit"
import type { PhysicalRisk } from "@/entities/physical-risk/model/physical-risk.types"

export type PreventionActionContext = {
  physicalRisks: PhysicalRisk[]
}

const preventionActionContextSelector = createSelector([(state: any) => state.physicalRisk.list], (physicalRisks) => ({
  physicalRisks
}))

const createPreventionActionStore = () => {
  const base = createEntityStore<PreventionAction, PreventionActionContext>(
    PREVENTION_ACTION_ENTITY,
    createEmptyPreventionAction,
    preventionActionContextSelector,
    (entity, _session, context) => formatPreventionAction(entity, context)
  )

  /**
   * Get by site
   */
  const listForRisk = createSelector(
    [base.selectors.list, (_state, activeRiskId: string) => activeRiskId],
    (actions, activeRiskId) => {
      return actions.filter((x) => x.PhysicalRiskId === activeRiskId)
    }
  )

  /**
   * Mesures RPS d'une fonction : les siennes et celles de tout l'etablissement.
   * Sans fonction, toutes les mesures RPS.
   */
  const listRps = createSelector(
    [base.selectors.list, (_state, populationId?: string) => populationId],
    (actions, populationId) =>
      actions.filter(
        (action) =>
          isRpsPreventionAction(action) && (!populationId || isRpsPreventionActionForPopulation(action, populationId))
      )
  )

  return {
    ...base,
    selectors: {
      ...base.selectors,
      listForRisk,
      listRps
    },
    thunks: {
      ...base.thunks,
      add,
      remove,
      updateStatus
    }
  }
}

const preventionActionStore = createPreventionActionStore()
export default preventionActionStore
